import React from 'react';

import ProjectMaterialForm from './ProjectMaterialForm';

const ProjectReceipt = () => {
  return <ProjectMaterialForm mode="receipt" />;
};

export default ProjectReceipt;
